import { onlineManager, useSuspenseQueries } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { queryKeys } from '@/queries/keys'
import { getAddOnsQueryOptions } from '@/queries/query/add-ons'
import { BusDetailAddOnsSearchSchema } from '@/schemas/page'
import {
  getBookingQueryOptions,
  getBookingTransportationQueryOptions,
} from '@/queries/query'
import AddOns from '@/pages/make-booking/bus-details/AddOns'

export const Route = createFileRoute(
  '/make-booking/$id/bus-details/$transportationId/add-ons/',
)({
  validateSearch: BusDetailAddOnsSearchSchema,
  loader: ({ context, params }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return [
        context.queryClient.ensureQueryData(
          getBookingTransportationQueryOptions(params.transportationId),
        ),
        context.queryClient.ensureInfiniteQueryData(
          getAddOnsQueryOptions({ booking_id: params.transportationId }),
        ),
      ]
    }
    return [
      context.queryClient.getQueryData(
        queryKeys.booking.transportation(params.transportationId),
      ),
      context.queryClient.getQueryData(
        queryKeys.addOns.list({ booking_id: params.transportationId }),
      ),
    ]
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { id, transportationId } = Route.useParams()

  const [bookingQuery, transportationQuery] = useSuspenseQueries({
    queries: [
      getBookingQueryOptions(id),
      getBookingTransportationQueryOptions(transportationId),
    ],
  })

  const {
    data: {
      data: { booking },
    },
  } = bookingQuery

  const {
    data: {
      data: { booked_transportation: transportation },
    },
  } = transportationQuery

  return <AddOns booking={booking} transportation={transportation} />
}
